import { useEffect, useRef, useState } from 'react';

export function useSticky<T extends Element | null>() {
  const ref = useRef<T>(null);
  const [isSticky, setIsSticky] = useState(false);
  const [rect, setRect] = useState<DOMRectReadOnly | null>(null);

  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      ([e]) => {
        const s = (e && e.intersectionRatio && e.intersectionRatio < 1) || false;
        setIsSticky(s);
        setRect(s ? (e?.boundingClientRect ?? null) : null);
      },
      {
        threshold: [1],
      },
    );
    observer.observe(ref.current);
  }, []);

  return { ref, isSticky, rect };
}
